import React, { useState } from 'react'
import Container from '../containerComp/Container'
import { ActivityLogPropsTypes } from './ActivityLogTypes'


const ActivityLog = (props: ActivityLogPropsTypes) => {

    return (
        <Container title='activity log'>
            
        </Container>
    )
}

export default ActivityLog